/* GOLVIVE ™ — reviews carousel + CTA scroll-to-buybox */
(function(){
  function ready(fn){if(document.readyState!='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}

  /* ---- CTA: scroll to product info / quantity selector ---- */
  function scrollToBuy(){
    var target = document.querySelector('.quantity-break')
      || document.querySelector('variant-selects')
      || document.querySelector('.product-form__buttons')
      || document.querySelector('.product-form')
      || document.querySelector('#MainProduct, .main-product, [id^="shopify-section"][id*="product"]');
    if(!target) return;
    var header = document.querySelector('.section-header, sticky-header, header.header, #shopify-section-sections--header');
    var off = header ? Math.min(header.getBoundingClientRect().height, 90) : 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - off - 12;
    if(y<0) y=0;
    var start=window.pageYOffset;
    try{ window.scrollTo({top:y, left:0, behavior:'smooth'}); }catch(e){ window.scrollTo(0,y); }
    /* guaranteed fallback: if the env ignored smooth scrolling, jump instantly */
    setTimeout(function(){ if(window.pageYOffset===start && start!==y) window.scrollTo(0,y); }, 90);
  }
  function bindCtas(){
    document.querySelectorAll('[data-glv-scroll]').forEach(function(b){
      if(b.__glv) return; b.__glv=1;
      b.addEventListener('click',function(e){e.preventDefault();scrollToBuy();});
    });
  }

  /* ---- Reviews carousel ---- */
  function initCarousels(){
    document.querySelectorAll('.glv-car').forEach(function(car){
      if(car.__glv) return; car.__glv=1;
      var track=car.querySelector('.glv-car-track');
      var cards=car.querySelectorAll('.glv-card');
      var dots=car.querySelectorAll('.glv-dot');
      var prev=car.querySelector('.glv-car-prev');
      var next=car.querySelector('.glv-car-next');
      var i=0, n=cards.length;
      if(!n) return;
      function go(k){
        i=(k+n)%n;
        track.style.transform='translateX(-'+(i*100)+'%)';
        dots.forEach(function(d,di){d.classList.toggle('active',di===i);});
      }
      if(prev)prev.addEventListener('click',function(){go(i-1);});
      if(next)next.addEventListener('click',function(){go(i+1);});
      dots.forEach(function(d,di){d.addEventListener('click',function(){go(di);});});
      /* swipe */
      var x0=null;
      car.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
      car.addEventListener('touchend',function(e){
        if(x0===null)return; var dx=e.changedTouches[0].clientX-x0;
        if(Math.abs(dx)>40){dx<0?go(i+1):go(i-1);} x0=null;});
      go(0);
    });
  }

  ready(function(){bindCtas();initCarousels();});
})();
